<div class="select-claim-container" [ngClass]="{'mox-style mox-ui-page-container mox-ui-m-pb-130': claim.isMox()}">
    <div class="prev-bar">
        <a (click)="back()"  style="color: #0064c1" class="btn btn-secondary new-btn"><i class="fas fa-arrow-left"></i>&nbsp;{{'claimDetails.body.back' | translate}}&nbsp;</a>
        <a (click)="back()" class="back-chevron"></a>
    </div>
    <ng-container [ngTemplateOutlet]="isTravel ? travelPanel : isHome ? homePanel : defaultPanel"></ng-container>
    <div class="submit-bar">
        <a href="javascript:;" (click)="showModal()" class="Tertiary" [hidden]="claim.isMox()"> {{'claimDetails.body.save' | translate}}</a>
        <abandon-button></abandon-button>
        <button (click)="goToNext()"  class="new-btn btn btn-primary float-right">&nbsp;{{'claimDetails.body.next' | translate}}&nbsp;<i class="fas fa-arrow-right"></i></button>
    </div>
    <app-save-box [showTotalBox]="showTotalBox" (childEvent)="getData($event)"></app-save-box>
</div>

<ng-template #defaultPanel>
    <div class="col-12">
        <h5> {{'claimDetails.body.title' | translate}}</h5>
        <p *ngIf="!this.transactionInfo.isHomeProduct() && !this.transactionInfo.isEmployeeCompensationProduct()">{{'claimDetails.body.selectType' | translate}}</p>
        <p *ngIf="this.transactionInfo.isHomeProduct()">{{'claimDetails.body.selectCauseType' | translate}}</p>
        <ng-container *ngIf="this.transactionInfo.isEmployeeCompensationProduct()">
            <p>{{'ecClaim.selectClaim.subHeading1' | translate}}</p>
            <p>{{'ecClaim.selectClaim.subHeading2' | translate}}</p>
        </ng-container>
        <qnect-notification-messages [notifications]="notifications"></qnect-notification-messages>
    </div>
    <div class="row claimTypeBox col-12 default-claim-type" [ngClass]="{'claim-type-container': claim.isMox()}">
        <div [ngClass]="{'col-lg-3 col-md-6 col-sm-6': this.transactionInfo.isHomeProduct() || this.transactionInfo.isEmployeeCompensationProduct(),
             'col-lg-4 col-md-6 col-sm-6': this.transactionInfo.isDomesticHelperProduct() || this.transactionInfo.isMotorProduct() || this.transactionInfo.isAccidentProduct()}"
             *ngFor="let claimType of claimTypeData; let i = index" (click)="toggleActive(claimType.claimTypeId, claimType)" [hidden]="!claimType.show">
            <div class="cperson-wrapper text-center" style="height: 200px;display: flex;align-items: center;justify-content: center;" [class.active]="chooseIndex == claimType.claimTypeId || claimType.selected" [ngClass]="{'select-item select-item-height': claim.isMox() && claim.getProduct() === 'PTR'}">
                <div [ngClass]="!this.transactionInfo.isMotorProduct() ? 'cpreson-outter' : 'cpreson-outter-motor-icons'" style="align-items:center; display: flex; justify-content: center">
                    <div>
                        <img class="icon" [src]="claimType['icon']" alt="Claim Type Icon">
                        <h5 style="margin-top: 10px;">{{claimType.claimTypeIdName | translate}}</h5>
                        <h6 *ngIf="claimType.description != ''"> {{claimType.description | translate}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row col-12" *ngIf="this.transactionInfo.isEmployeeCompensationProduct()">
        <div class="col-md-12 col-sm-12">
            <p>
                <a href="javascript:;" (click)="formSelectionModal.open();" class="click-more">{{ 'ecClaim.selectClaim.clickHere' | translate}}</a>
                {{ 'ecClaim.selectClaim.unsureForm' | translate}}
            </p>
        </div>
    </div>
</ng-template>

<ng-template #travelPanel>
    <div class="col-12">
        <h5> {{'claimDetails.body.whatHappened' | translate}}</h5>
        <p>{{'claimDetails.body.pickOne' | translate}}</p>
        <qnect-notification-messages [notifications]="notifications"></qnect-notification-messages>
    </div>
    <div class="row claimTypeBox col-12" [ngClass]="{'mox-ptr-claim-type claim-type-container': claim.isMox()}">
        <ng-container *ngIf="disruptedSubGroup?.length > 0">
        <!-- Incident with your trip-->
        <div class="claimTypeItem claimTypeIncident col-lg-3 col-md-6 col-sm-6" [ngClass]="{'claim-item claim-type-item': claim.isMox()}"
             [class.active]="disruptedSubGroup[0]?.isActive || disruptedSubGroup[1]?.isActive">
            <div class="claim-header-wrapper" (click)="toggleIncAccordion()">
                <div class="claim-header-icon incidentTrip"></div>
                <div class="claim-header-text-wrapper">
                    <h5 style="margin-top: 10px;">{{'claimDetails.claimTypeName.incidentWithYourTrip' | translate}}</h5>
                    <p>{{'claimDetails.claimTypeName.wasDelayedCancelledOrCutShort' | translate}}</p>
                </div>
                <div class="claim-header-dropdown" [ngClass]="isExpanded ? 'open' : 'close'"></div>
            </div>
            <div class="claim-type-item-container claim-type-incident-container" *ngIf="isExpanded">
                <div class="claim-type-item-wrapper" *ngFor="let subGroup of disruptedSubGroup; let k = index" [ngClass]="{'mox-ui-full-width': claim.isMox()}">
                    <div class="claim-outter-wrapper claim-wrapper-item"
                         [class.active]="subGroup.isActive">
                        <div class="claim-header-wrapper" (click)="toggleAccordion(subGroup)">
                            <div class="claim-header-text-wrapper">
                                <h5 style="margin-top: 10px;">{{subGroup.claimTypeGroupName | translate}}</h5>
                                <p>{{subGroup.description | translate}}</p>
                            </div>
                            <div class="claim-header-dropdown" [ngClass]="subGroup.isExpanded ? 'open' : 'close'"></div>
                        </div>
                    </div>
                    <div class="claim-mid-wrapper" *ngIf="subGroup.isExpanded">
                        <div class="claim-inner-mid-wrapper claim-inner-mid-incident" *ngFor="let claimType of subGroup.claimTypeData; let j = index"
                             (click)="toggleActive(claimType.claimTypeId, claimType, subGroup)" [ngClass]="{'mox-ui-full-width': claim.isMox()}">
                            <div class="cperson-wrapper text-center claim-inner-wrapper" [class.type-disabled]="claimType.disabled" style="height: 200px;display: flex;align-items: center;justify-content: center;"
                                 [class.active]="chooseIndex == claimType.claimTypeId || claimType.selected" [ngClass]="{'select-item select-item-height': claim.isMox() && claim.getProduct() === 'PTR'}">
                                <div class="claim-text-wrapper cpreson-outter" [class.disabled]="claimType.disabled">
                                    <h5 class="claim-type-incident-h5" style="margin-top: 10px;">{{claimType.claimTypeIdName | translate}}</h5>
                                    <h6>{{claimType.description | translate}}</h6>
                                </div>
                                <div *ngIf="claimType.claimTypeCode === 'CLAIM_TYPE_TDEL' && claimType.disabled">
                                  <i class="hits">
                                    <div class="popover-wrapper" [innerHTML]="'claimDetails.claimTypeTooltip.basic.disabled' | translate"></div>
                                  </i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </ng-container>
        <!-- Loss or damage, Sickness or injury, Other incidents -->
       <div class="claimTypeItem col-lg-3 col-md-6 col-sm-6" *ngFor="let subGroup of otherSubGroup; let k = index" [ngClass]="{'claim-item claim-type-item': claim.isMox()}"
            [class.active]="subGroup.isActive">
            <div class="claim-outter-wrapper">
                <div class="claim-header-wrapper" (click)="toggleAccordion(subGroup)">
                    <div class="claim-header-icon" [class]="(subGroup.claimTypeGroupClassName)"></div>
                    <div class="claim-header-text-wrapper">
                        <h5 style="margin-top: 10px;">{{subGroup.claimTypeGroupName | translate}}</h5>
                        <p>{{subGroup.description | translate}}</p>
                    </div>
                    <div class="claim-header-dropdown" [ngClass]="subGroup.isExpanded ? 'open' : 'close'"></div>
                </div>
                <div class="claim-mid-wrapper" *ngIf="subGroup.isExpanded">
                    <div class="claim-inner-mid-wrapper" *ngFor="let claimType of subGroup.claimTypeData; let j = index"
                         (click)="toggleActive(claimType.claimTypeId, claimType, subGroup)" [ngClass]="{'mox-ui-full-width': claim.isMox()}">
                        <div class="cperson-wrapper text-center claim-inner-wrapper" style="height: 200px;display: flex;align-items: center;justify-content: center;" [class.type-disabled]="claimType.disabled"
                             [class.active]="chooseIndex == claimType.claimTypeId || claimType.selected" [ngClass]="{'select-item select-item-height': claim.isMox() && claim.getProduct() === 'PTR'}">
                            <div class="claim-text-wrapper cpreson-outter" [class.disabled]="claimType.disabled">
                                <h5 style="margin-top: 10px;">{{claimType?.caption ? (claimType.caption | translate) : (claimType.claimTypeIdName | translate)}}</h5>
                                <h6>{{claimType.description | translate}}</h6>
                            </div>
                            <div *ngIf="claimType.claimTypeCode === 'CLAIM_TYPE_BDEL' && claimType.disabled">
                                <i class="hits">
                                    <div class="popover-wrapper" [innerHTML]="'claimDetails.claimTypeTooltip.basic.disabled' | translate"></div>
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</ng-template>

<ng-template #homePanel>
    <div class="col-12">
        <h5> {{'claimDetails.body.title' | translate}}</h5>
        <p *ngIf="!this.transactionInfo.isHomeProduct() && !this.transactionInfo.isEmployeeCompensationProduct()">{{'claimDetails.body.selectType' | translate}}</p>
        <p *ngIf="this.transactionInfo.isHomeProduct()">{{'claimDetails.body.selectCauseType' | translate}}</p>
        <ng-container *ngIf="this.transactionInfo.isEmployeeCompensationProduct()">
            <p>{{'ecClaim.selectClaim.subHeading1' | translate}}</p>
            <p>{{'ecClaim.selectClaim.subHeading2' | translate}}</p>
        </ng-container>
        <qnect-notification-messages [notifications]="notifications"></qnect-notification-messages>
    </div>
    <div class="row claimTypeBox col-12 mox-hpk-claim-type" [ngClass]="{'claim-type-container': claim.isMox()}">
        <div [ngClass]="{'col-lg-3 col-md-6 col-sm-6': this.transactionInfo.isHomeProduct() || this.transactionInfo.isEmployeeCompensationProduct(),
             'col-lg-4 col-md-6 col-sm-6': this.transactionInfo.isDomesticHelperProduct() || this.transactionInfo.isMotorProduct() || this.transactionInfo.isAccidentProduct(),
             'claim-item': claim.isMox()}"
             *ngFor="let claimType of claimTypeData; let i = index" (click)="toggleActive(claimType.claimTypeId, claimType)" [hidden]="!claimType.show">
            <div class="cperson-wrapper text-center" style="height: 200px;display: flex;align-items: center;justify-content: center;" [class.active]="chooseIndex == claimType.claimTypeId || claimType.selected" [ngClass]="(claim.isMox() && claim.getProduct() === 'HPK') ? 'select-item select-item-height check-pos-left check-pos-top-50 select-hpk-item-' + i : ''">
                <div [ngClass]="!this.transactionInfo.isMotorProduct() ? 'cpreson-outter' : 'cpreson-outter-motor-icons'" style="align-items:center; display: flex; justify-content: center">
                    <div>
                        <img class="icon" [src]="claimType['icon']" alt="Claim Type Icon">
                        <h5 style="margin-top: 10px;">{{claimType.claimTypeIdName | translate}}</h5>
                        <h6 *ngIf="claimType.description != ''"> {{claimType.description | translate}}</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row col-12" *ngIf="this.transactionInfo.isEmployeeCompensationProduct()">
        <div class="col-md-12 col-sm-12">
            <p>
                <a href="javascript:;" (click)="formSelectionModal.open();" class="click-more">{{ 'ecClaim.selectClaim.clickHere' | translate}}</a>
                {{ 'ecClaim.selectClaim.unsureForm' | translate}}
            </p>
        </div>
    </div>
</ng-template>

<ng-template #alert_claim_type let-c="close" let-d="dismiss">
  <div class="modal-header">
      <h4 class="modal-title cursor-pointer">{{'error_messages.notificationsErrMsg.sameClaimTypeMsg1'  | translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="continue()">
          <span aria-hidden="true">&times;</span>
      </button>
  </div>
  <div class="modal-body">
      <p>{{'error_messages.notificationsErrMsg.sameClaimTypeMsg2' | translate}}</p>
  </div>
  <div class="modal-footer">
      <div class="col-md-12">
          <button type="button" class="btn btn-default btn-sm" (click)="continue()">{{'claimSection.generalLabels.generalButtonLabels.close'  | translate}}</button>
      </div>
  </div>
</ng-template>

<ng-template #confirm_delete_claim_type let-c="close" let-d="dismiss">
  <div [ngClass]="{'mox-style': claim.isMox()}">
      <div class="modal-header">
          <h5 class="modal-title">{{'sideMenu.deleteClaim.header' | translate }}</h5>
          <button type="button" class="close" aria-label="Close" (click)="cancelDeleteClaimType()">
              <span aria-hidden="true">&times;</span>
          </button>
      </div>
          <ng-container *ngIf="transactionInfo.isAccidentProduct() || transactionInfo.isHomeProduct()">
              <div class="modal-body">
                  <p *ngIf="!claim.isMox()">{{'sideMenu.deleteClaim.question1' | translate }}</p>
                  <p *ngIf="claim.isMox()">{{'sideMenu.deleteClaim.question-mox' | translate }}</p>
              </div>
          </ng-container>
          <ng-container *ngIf="transactionInfo.isTravelProduct()">
              <div class="modal-body modal-text-wrapper" [innerHTML]="'sideMenu.deleteClaim.questionTravel' | translate"></div>
          </ng-container>
      <div class="modal-footer">
          <div class="col-md-6 text-right">
              <button type="button" class="btn btn-primary btn-sm" (click)="deleteClaimType()">
                  <span *ngIf="!claim.isMox()">{{'sideMenu.deleteClaim.yes' | translate }}</span>
                  <span *ngIf="claim.isMox()">{{'sideMenu.deleteClaim.yes-mox' | translate }}</span>
              </button>
          </div>
          <div class="col-md-6 text-left">
              <button type="button" class="btn btn-default btn-sm modal-btn-secondary" (click)="cancelDeleteClaimType()">
                  <span *ngIf="!claim.isMox()">{{'sideMenu.deleteClaim.no' | translate }}</span>
                  <span *ngIf="claim.isMox()">{{'sideMenu.deleteClaim.no-mox' | translate }}</span>
              </button>
          </div>
      </div>
  </div>
</ng-template>

<ec-form-selection-modal #ec_form_selection_modal [claimTypeData]="claimTypeData" (onConfirmEmit)="onConfirmECFormSelection($event)"></ec-form-selection-modal>
